
import React, { Component } from "react";
import iconFind from "../../../assets/images/icons/paint.png";

export interface IconPaintProps
{
}

interface IconPaintState 
{
}

export class IconPaint extends Component<IconPaintProps, IconPaintState>
{
    constructor(props: IconPaintProps)
    {
        super(props);

        this.state = {
        };
    }

    public render(): JSX.Element
    {
        return (
            <div className="icon">
                <img src={iconFind} alt="paint" style={{ maxWidth: "100%" }} />
            </div>
        );
    }
}